import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Observable, observable } from 'rxjs';
import {environment} from '../../../../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class ClientService {

  private apiURL = environment.api;
  constructor(private http: HttpClient) { }
  addClient(data,client_id):Observable<any>{
    return this.http.post(`${this.apiURL}client/add/`+client_id,data,httpOptions);
  }
  searchCompany(data):Observable<any>{
    return this.http.get(`${this.apiURL}company/search/`+data);
  }
  editClient(client_id):Observable<any>{
    return this.http.get(`${this.apiURL}client/edit/`+client_id);
  }
  getClientDetails(client_id):Observable<any>{
    return this.http.get(`${this.apiURL}client/details/`+client_id);
  }
  // DataTables-style request (search, order, start/length, badge); length -1 returns every match.
  listClients(params):Observable<any>{
    return this.http.post(`${this.apiURL}client/list`, params, httpOptions);
  }
  deleteClient(client_id):Observable<any>{
    return this.http.get(`${this.apiURL}client/delete/`+client_id);
  }
  saveCompany(data):Observable<any>{
    return this.http.post(`${this.apiURL}company/save`, data, httpOptions);
  }
  getPreferredInspectors(client_id):Observable<any>{
    return this.http.get(`${this.apiURL}client/preferred_inspectors/`+client_id);
  }
  getInspectorsList():Observable<any>{
    return this.http.get(`${this.apiURL}inspectors`);
  }
  addPreferredInspector(client_id, inspector_id):Observable<any>{
    return this.http.post(`${this.apiURL}client/preferred_inspector/add`, {client_id, inspector_id}, {});
  }
  removePreferredInspector(client_id, inspector_id):Observable<any>{
    return this.http.post(`${this.apiURL}client/preferred_inspector/remove`, {client_id, inspector_id}, {});
  }
  updateNotes(clientId, notes: string):Observable<any>{
    return this.http.post(`${this.apiURL}client/notes/${clientId}`, {client_notes: notes}, httpOptions);
  }
  updateVip(clientId, vip: number):Observable<any>{
    return this.http.post(`${this.apiURL}client/vip/${clientId}`, {vip}, httpOptions);
  }
  updateAlert(clientId, client_alert: number):Observable<any>{
    return this.http.post(`${this.apiURL}client/alert/${clientId}`, {client_alert}, httpOptions);
  }
  uploadPhoto(clientId, file: File):Observable<any>{
    const formData = new FormData();
    formData.append('photo', file);
    return this.http.post(`${this.apiURL}client/photo/${clientId}`, formData);
  }
}
